import PDFSettingsTab from './pdf-settings';

export default PDFSettingsTab;
